import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  get checkboxTargets () {
    return this.element.querySelectorAll('input[type="checkbox"]')
  }

  clearAll () {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event('change'))
    })
  }

  selectAll () {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
      checkbox.dispatchEvent(new Event('change'))
    })
  }
}
